import { GridColDef } from '@mui/x-data-grid';
import IGridComponent from '../../../components/grid/i-grid.component';
import { useContext, useState } from 'react';
import { AppContext } from '../../../app-context';
import { getMasterDataById } from '../../master-data/masterdata.services';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import SpecsComponent from '../../master-data/specs/specs.component';

const InputDataComponent = (props: any) => {
  const appContext = useContext(AppContext);
  const [specsData, setSpecsData] = useState(null);
  const [openSpecs, setOpenSpecs] = useState(false);
  const columns: GridColDef[] = [
    { field: 'inputSerial', headerName: 'Input #', filterable: true, sortable: false, editable: false, width: 90 },
    { 
      field: 'inputCode', headerName: 'Input Code', filterable: true, sortable: false, editable: false, width: 100,
      renderCell: (params) => { return <div className="cell-link"
      onClick={() => { openSpecsPopup(params.row)}}>{params.row.inputCode}</div> }
    },
    { field: 'input', headerName: 'Input', filterable: true, sortable: false, editable: false, width: 150 },
    { field: 'output', headerName: 'Output', filterable: true, sortable: false, editable: false, width: 300 },
  ];

  const openSpecsPopup = (row: any) => {
    getMasterDataById(row.inputId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setSpecsData(response.data);
        setOpenSpecs(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  };

  const closeSpecs = () => {
    setOpenSpecs(false);
  }

  return <>
    <IGridComponent title={''} rows={props.data} columns={columns} maxHeight={450} hideFooterPagination={true}
      showAddBtn={false} showApproveAction={false} showDeleteAction={false} showUpAction={false} showDownAction={false}
      getRowId={(row: any) => row.inputId} hideFooter={true}/>
    <IDialogComponent onClose={closeSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
      dialogBody={<SpecsComponent data={specsData} />} />
  </>
}

export default InputDataComponent;